import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Smartphone } from 'lucide-react';
import HomeScreenInstructions from './HomeScreenInstructions';

export const AddToHomeScreenDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="add-to-home-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-violet-600 dark:text-violet-400">
          <Smartphone className="w-5 h-5" /> Add to Home Screen
        </DialogTitle>
      </DialogHeader>
      <p className="text-sm text-muted-foreground">
        Business Bestie is a web app — add it to your device's Home Screen for quick, one-tap access, just like a regular app.
      </p>
      <HomeScreenInstructions />
    </DialogContent>
  </Dialog>
);

export default AddToHomeScreenDialog;
